const setLoadingApp = ( status = false ) => dispatch => dispatch({ type: status ? 'LOADING_ON' : 'LOADING_OFF' , data: status });
export {
    setLoadingApp
}